import { Sparkles } from 'lucide-react'

interface ComingSoonOverlayProps {
  level: 'L2' | 'L3'
  featureName: string
}

export function ComingSoonOverlay({ level, featureName }: ComingSoonOverlayProps) {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/50 dark:bg-black/30 backdrop-blur-[2px] rounded-lg pointer-events-none">
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-muted/90 border text-xs font-semibold text-muted-foreground shadow-sm">
        <Sparkles className="h-3.5 w-3.5" />
        <span>Preview</span>
        <span className="mx-0.5 text-muted-foreground/40">·</span>
        <span>{level} {featureName} — Coming Soon</span>
      </div>
    </div>
  )
}
